const individualBulkBookingSearchResult = (state = null, action) => {
  if (action.type === "SET_INDIVIDUAL_BULK_BOOKING_SEARCH_RESULT") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_INDIVIDUAL_BULK_BOOKING_SEARCH_RESULT": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default individualBulkBookingSearchResult;
